export const mappingPropertyType = {
  integer: 0,
  decimal: 1,
  string: 2,
  enum: 3,
  lookup: 4,
  boolean: 5,
  date: 6,
};
